import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../services/api';
import './InquiryDetail.css';

const InquiryDetail = () => {
	const { id } = useParams();
	const navigate = useNavigate();
	const [inquiry, setInquiry] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		fetchInquiry();
	}, [id]);

	const fetchInquiry = async () => {
		try {
			const token = localStorage.getItem('access_token');
			const response = await fetch(`${API_BASE_URL}/products/inquiries/${id}/`, {
				headers: { Authorization: `Bearer ${token}` }
			});
			
			if (response.status === 401) {
				alert('로그인이 필요합니다.');
				navigate('/login');
				return;
			}
			
			if (!response.ok) {
				throw new Error(`HTTP ${response.status}`);
			}
			
			const data = await response.json();
			console.log('📡 문의 상세 데이터:', data);
			setInquiry(data);
		} catch (error) {
			console.error('문의 로딩 실패:', error);
		} finally {
			setLoading(false);
		}
	};

	if (loading) return <div className="loading">로딩 중...</div>;
	if (!inquiry) return <div>문의를 찾을 수 없습니다.</div>;

	return (
		<div className="inquiry-detail-container">
			<div className="inquiry-header">
				<span className={`badge-status ${inquiry.status}`}>
					{inquiry.status_display}
				</span>
				<h1>{inquiry.title}</h1>
				<p className="inquiry-date">
					{new Date(inquiry.created_at).toLocaleDateString()}
				</p>
			</div>

			<div className="inquiry-content">
				<h3>📝 문의 내용</h3>
				<p style={{ whiteSpace: 'pre-wrap' }}>{inquiry.content}</p>
			</div>

			{/* 답변 표시 - status 또는 answer 존재 여부로 체크 */}
			{(inquiry.status === 'answered' || inquiry.answer) && inquiry.answer && (
				<div className="inquiry-answer">
					<h3>💬 답변</h3>
					<p style={{ whiteSpace: 'pre-wrap' }}>{inquiry.answer}</p>
					{(inquiry.answered_by_name || inquiry.answered_at) && (
						<p className="answer-info">
							{inquiry.answered_by_name && `답변자: ${inquiry.answered_by_name}`}
							{inquiry.answered_by_name && inquiry.answered_at && ' | '}
							{inquiry.answered_at && new Date(inquiry.answered_at).toLocaleString()}
						</p>
					)}
				</div>
			)}

			<button onClick={() => navigate('/inquiry')} className="btn-back">
				목록으로
			</button>
		</div>
	);
};

export default InquiryDetail;